// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FsqRq","rootMobile":"styles_rootMobile__2fqoA"};